<template>
  <div class="tab-cover-wrap ">
    <div class="tab-cover">
      <Tabs />
    </div>
  </div>
</template>

<script>
import Tabs from './Tabs.vue';

export default {
  components: {
    Tabs,
  },
 
};

</script>